export default "__VITE_ASSET__BFACmcJq__"